var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 45,
    viewBox: "0 0 43 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1475_9790)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.4844 -0.00878906C22.0651 14.1648 28.9449 21.6772 43 22.4327C28.9708 23.1775 21.9355 30.6314 21.417 44.9912C20.7794 30.9294 14.1588 23.1403 0 22.4061C13.9151 21.6187 20.8675 14.1009 21.4844 -0.00878906Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1475_9790"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 43,
    height: 45,
    fill: "white",
    transform: "translate(0 -0.00878906)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackStar);
export default __webpack_public_path__ + "static/media/black-star.51c6f8c033b3d9982cb35949178ee490.svg";
export { ForwardRef as ReactComponent };